import React from "react";
import Navbar from "../components/navbar/Navbar";

const main = () => {
  return (
    <div className="navbar-page-offset">
      <Navbar />
      <div className="container">
        <h1>Main</h1>
      </div>
    </div>
  );
};

export default main;
